import React from 'react';
import TextField from '@mui/material/TextField';
const InputHtmlRenderer = (props) => {
    const { data } = props;
    const name = data === null || data === void 0 ? void 0 : data.name;
    const label = data === null || data === void 0 ? void 0 : data.label;
    const defaultValue = data === null || data === void 0 ? void 0 : data.defaultValue;
    const required = data === null || data === void 0 ? void 0 : data.required;
    const color = data === null || data === void 0 ? void 0 : data.color;
    const inputDataChange = props.inputDataChange;
    const multiline = data === null || data === void 0 ? void 0 : data.multiLine;
    const type = data === null || data === void 0 ? void 0 : data.type;
    const rows = multiline ? 10 : 1;
    return (React.createElement("div", null,
        React.createElement(TextField, { className: 'form-input', fullWidth: true, required: required ? true : false, rows: rows, id: name, label: label, defaultValue: defaultValue, onChange: inputDataChange, color: "primary", multiline: multiline, type: type })));
};
export default InputHtmlRenderer;
//# sourceMappingURL=InputHtmlRenderer.js.map